<template>
    <v-btn icon @click="badgeCount = 0">

        <v-badge :model-value="badgeCount" color="secondary" :content="badgeCount">
            <v-icon icon="mdi-bell-outline" />
        </v-badge>

        <v-menu :close-on-content-click="false" activator="parent" location="bottom">
            <v-card min-width="300" min-height="200">

                <v-list class="pa-0" max-height="500">
                    <v-empty-state v-if="!alerts.length" title="No Alerts"
                        text="When you receive an alert, it'll show up here" icon="mdi-sleep" size="50" />

                    <v-alert v-else v-for="alert in alerts.slice().reverse()" :key="alert.id"
                        class="px-3 border-b-sm border-background border-opacity-100" density="compact" variant="tonal"
                        border :type="alert.type" :rounded="0">

                        <v-alert-title class="text-subtitle-1 font-weight-bold mb-0" v-if="alert.title">
                            {{ alert.title }}
                        </v-alert-title>

                        <p class="text-body-2 mb-0" v-if="alert.text">{{ alert.text }}</p>

                        <div class="d-flex justify-space-between">

                            <span class="text-overline mb-0" style="line-height: 3" v-if="alert.code">Code: {{
                                alert.code }}</span>

                            <span class="text-caption mb-0" style="line-height: 3" v-if="alert.timestamp">{{
                                new Intl.DateTimeFormat('en-GB', {
                                    dateStyle: 'short',
                                    timeStyle: 'short',
                                }).format(new Date(alert.timestamp))
                            }}</span>
                        </div>
                    </v-alert>
                </v-list>

            </v-card>
        </v-menu>

    </v-btn>
</template>

<script>

export default {
    name: 'AlertsMenu',
    data() {
        return {
            badgeCount: 0,
        }
    },
    props: {
        alerts: Array,
    },
    watch: {
        alerts: {
            handler() {
                this.badgeCount++;
            },
            deep: true,
        },
    },
}
</script>